<template>
  <section
    v-loading="loading"
    class="new-case-view case-creation"
    id="single-case-view"
  >
    <div
      :class="{
        beforeStickyNavbar: scrollPosition < 100,
        stickyNavbar: scrollPosition > 100,
      }"
    >
      <div class="container-sm">
        <div class="inside">
          <div class="case-status">
            <el-row type="flex" :align="middle">
              <el-col
                :sm="4"
                v-if="hasPermission('cases', 'edit') && !isBillingUser"
              >
                <div class="editCase">
                  <button class="editButton btn" @click="goToEditForm">
                    <span class="pr-5"> EDIT </span>
                  </button>
                </div>
              </el-col>
              <el-col
                :sm="4"
                v-if="
                  !isCaseCompleted &&
                  hasPermission('cases', 'edit') &&
                  isBillingUser
                "
              >
                <div class="editCase">
                  <button class="editButton btn" @click="goToEditForm">
                    <span class="pr-5"> EDIT </span>
                  </button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>
          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <div class="case-creation__step case-creation__patient-information">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-case-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Mileage Information</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <div class="vue-form">
                  <el-row :gutter="30">
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <h4 class="name">Accession Id</h4>
                        <p
                          class="value"
                          v-if="
                            getMileageCaseInformation &&
                            getMileageCaseInformation.accession_id
                          "
                        >
                          {{ getMileageCaseInformation.accession_id }}
                        </p>
                        <p class="value" v-else>--</p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <h4 class="name">Residence Type</h4>
                        <p
                          class="value"
                          v-if="
                            getMileageCaseInformation &&
                            getMileageCaseInformation.residence_type
                          "
                        >
                          {{ getMileageCaseInformation.residence_type }}
                        </p>
                        <p class="value" v-else>--</p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <h4 class="name">Encore Miles</h4>
                        <p
                          class="value"
                          v-if="
                            getMileageCaseInformation &&
                            getMileageCaseInformation.encore_miles
                          "
                        >
                          {{ getMileageCaseInformation.encore_miles }}
                        </p>
                        <p class="value" v-else>--</p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <h4 class="name">Technician</h4>
                        <p
                          class="value"
                          v-if="
                            getMileageCaseInformation &&
                            getMileageCaseInformation.technician
                          "
                        >
                          {{ getMileageCaseInformation.technician }}
                        </p>
                        <p class="value" v-else>--</p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div
                        class="input-value view-cases"
                        v-if="
                          getMileageCaseInformation &&
                          getMileageCaseInformation.lab_drop_off_date
                        "
                      >
                        <h4 class="name">Lab Drop-off Date</h4>
                        <p class="value">
                          {{
                            momentWithTimezone(
                              getMileageCaseInformation.lab_drop_off_date,
                              "MM-DD-yyyy"
                            )
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div
                        class="input-value view-cases"
                        v-if="
                          getMileageCaseInformation &&
                          getMileageCaseInformation.lab_drop_off_date
                        "
                      >
                        <h4 class="name">CPT Codes</h4>
                        <ul
                        v-if="
                          getMileageCaseInformation &&
                          getMileageCaseInformation.cpt_codes &&
                          getMileageCaseInformation.cpt_codes.length
                        "
                      >
                        <li
                          v-for="(cpt_code, index) in getMileageCaseInformation.cpt_codes"
                          :key="index"
                        >
                          {{ cpt_code }}
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                      <div
                        class="input-value view-cases"
                        v-if="
                          getMileageCaseInformation &&
                          getMileageCaseInformation.mileage_address
                        "
                      >
                        <h4 class="name">Mileage Address</h4>
                        <p class="value">
                          {{
                              getMileageCaseInformation.mileage_address                             
                          }}
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/cases/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/cases/CaseInformation")
);
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  components: {
    PatientInformation,
    CaseInformation,
  },
  mixins: [UserPermissionsHelper],

  data() {
    return {
      caseId: "",
      mId: "",
      loading: false,
    };
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    this.mId = this.$route.params.m_id;
    await this.fetchCaseInformation();
  },
  computed: {
    ...mapGetters("cases", ["getMileageCaseInformation"]),
  },
  methods: {
    goToEditForm() {
      this.$router.push({
        name: "Mileage-Case-Information-Update",
        params: {
          case_id: this.$route.params.case_id,
          m_id: this.$route.params.m_id,
        },
        query: { ...this.$route.query, editForm: "true" },
      });
    },
    async fetchCaseInformation() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);

        await this.$store.dispatch(
          "cases/fetchMileageCaseInformation",
          this.mId
        );

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.editCase {
  button {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid #f24a55;
    background: #f24a55;
    border-radius: 4px;
    padding: 0 10px;
    img {
      margin-right: 7px;
      margin-bottom: -3px;
      width: 15px;
    }
  }
}
</style>
